// Cannot use rankingsEntity type due to circular dependency issue
export const sortByRank = (p: { rank: { current: number | string } }) => {
  if (p.rank.current === 'NR') {
    return 9999999
  }
  return p.rank.current
}
